module.exports = __webpack_public_path__ + "img/0008.0ebb9a65.png";